import { updateSearchParam } from '@fukuri-admins/utils/common';
import { useSearchParams } from 'react-router-dom';
import { ActionInput } from '../../common/ActionInput';
import styles from './styles.module.scss';

export const RedeemableStoreCouponHistoryTableFilter: React.FC = () => {
  const [filterParams, setFilterParams] = useSearchParams();
  const updateFilterParams = (key: string, value: string) => {
    const newParams = updateSearchParam(filterParams, key, value);
    setFilterParams(newParams);
  };

  return (
    <div className={styles.root}>
      <div className={styles.form}>
        <label htmlFor='branch' className={styles.formTitle}>
          店舗名
        </label>
        <ActionInput
          id='branch'
          defaultValue={filterParams.get('branch')}
          action={e => updateFilterParams('branch', e.target.value)}
          placeholder='日比谷支店'
        />
      </div>
    </div>
  );
};
